<script>
import EnterAddress from "./EnterAddress";
import PinConfirmation from "./PinConfirmation";
import SelectDistrict from "./SelectDistrict";
import DataConfirmation from "./DataConfirmation";
import SetNameAndCreate from "./SetNameAndCreate";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },

  components: {
    EnterAddress,
    PinConfirmation,
    SelectDistrict,
    DataConfirmation,
    SetNameAndCreate
  },

  computed: {
    ...mapState("newAddress", ["district"])
  },

  data() {
    return {
      step: 0
    };
  },

  methods: {
    ...mapActions("newAddress", ["setAddressable"]),

    next(steps = 1) {
      if (this.step < 4) this.step += steps;
    },
    prev(steps = 1) {
      if (this.step > 0) this.step -= steps;
    },

    created(address) {
      this.$emit("created", address);
      this.$emit("close");
    }
  },

  mounted() {
    this.setAddressable(this.user);
  }
};
</script>

<template>
  <transition name="fade" mode="out-in">
    <enter-address v-if="step === 0" @next="next" @close="$emit('close')" />
    <select-district v-else-if="step === 1" @next="next" @prev="prev" />
    <pin-confirmation v-else-if="step === 2" @next="next" @prev="prev" />
    <data-confirmation v-else-if="step === 3" @next="next" @prev="prev" />
    <set-name-and-create v-else @prev="prev" @created="created($event)" />
  </transition>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/NewAddress/Index.vue